module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading == 'loading' || _vm.loading == 'completed') ? _c('div', [_c('div', {
    staticClass: "loading-bar-container"
  }, [_c('span', {
    class: ['loading-bar', _vm.loading]
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5266ab6e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingBar.vue
// module id = 1533
// module chunks = 4